import { ApiHttpClient } from "../../common/http/api-http-client";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { TaskFileDto } from "@/core/features/task-files/task-file.dto";
import { CreateTaskFileDto } from "@/core/features/task-files/create-task-file.dto";
import { UpdateTaskFileDto } from "@/core/features/task-files/update-task-file.dto";
import { HttpRequest } from "@/core/common/http/http-request";
import { TaskFileCategoryEnum } from "@altertec_gparn/lib";

export class TaskFilesResource extends ResourceBaseService<TaskFileDto, CreateTaskFileDto, UpdateTaskFileDto> {
  protected EntityDto = TaskFileDto;
  protected CreateEntityDto = CreateTaskFileDto;
  protected UpdateEntityDto = UpdateTaskFileDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/task-files");
  }

  makeFilesPublicByProjectId(projectId: string): Promise<number> {
    return this.apiHttpClient
      .request<void, number>(
        HttpRequest.create({
          url: this.resourceUrl + "/" + projectId + "/public",
          method: "PATCH",
          auth: true,
        })
      )
      .then((affected) => Number(affected));
  }

  async hasTaskFileWithCategory(taskId: string, category: TaskFileCategoryEnum): Promise<boolean> {
    const { total } = await this.findAll({ filters: { taskId, category }, limit: 1 });
    return (total ?? 0) > 0;
  }

  setReportSectionId(taskFileIds: string[], technicalReportSectionId: string) {
    return this.apiHttpClient.request(
      HttpRequest.create({
        url: this.resourceUrl + "/report-section",
        method: "PATCH",
        auth: true,
        body: { taskFileIds: taskFileIds, technicalReportSectionId: technicalReportSectionId },
      })
    );
  }
}
